const BulkStatusTypeName = "BulkStatus";
export {
  BulkStatusTypeName
};
//# sourceMappingURL=constants.js.map
